import axiosClient from "utils/api";
const URI = "drive/folders";

export const getAllRootFolders = async (payload) => {
  const URL = `${URI}/root`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get root folders :", error);
    throw error;
  }
};

export const getAllFoldersDetails = async (payload) => {
  const URL = `${URI}/details`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get root folders :", error);
    throw error;
  }
};

export const getAllFolders = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get root folders :", error);
    throw error;
  }
};
// export const getFolderDetails = async (payload) => {
//   const URL = `${URI}/details`;
//   try {
//     const response = await axiosClient().request({
//       url: URL,
//       method: "get",
//       params: payload,
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error occurred during get folder details :", error);
//     throw error;
//   }
// };

export const getFolderHierarchy = async (payload) => {
  const URL = `${URI}/${payload.id}/hierarchy`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get folder hierarchy :", error);
    throw error;
  }
};

export const createFolder = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during create folder :", error);
    throw error;
  }
};

export const updateFolder = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update folder :", error);
    throw error;
  }
};

export const restoreFolder = async (payload) => {
  const URL = `${URI}/${payload.id}/restore`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during restore folder :", error);
    throw error;
  }
};

export const moveFolder = async (payload) => {
  const { folderId, ...rest } = payload;
  const URL = `${URI}/${folderId}/move`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during move Folder :", error);
    throw error;
  }
};

export const getChildFolder = async (payload) => {
  const URL = `${URI}/${payload.id}/childs`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Child Folder :", error);
    throw error;
  }
};

export const grantPermissionFileFolder = async (payload) => {
  const { fileType, fileId, ...rest } = payload;
  const URL = `drive/${fileType}/${fileId}/permissions`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during grant Permission FileFolder :", error);
    throw error;
  }
};

export const getSharedDetails = async (payload) => {
  const URL = `drive/shareDetails`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Shared Details :", error);
    throw error;
  }
};

export const updatePermissionsFileFolder = async (payload) => {
  const { fileType, fileId, targetUserId, ...rest } = payload;
  const URL = `/drive/${fileType}/${fileId}/permissions/${targetUserId}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update Permissions :", error);
    throw error;
  }
};

export const deletePermissionsFileFolder = async (payload) => {
  const { fileType, fileId, targetUserId, ...rest } = payload;
  const URL = `/drive/${fileType}/${fileId}/permissions/${targetUserId}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during delete Permissions :", error);
    throw error;
  }
};

export const createShareLinkFileFolder = async (payload) => {
  const { fileType, ...rest } = payload;
  const URL = `/drive/sharedLink/${fileType}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error occurred during create Share Link File Folder :",
      error,
    );
    throw error;
  }
};

export const movesFileFolder = async (payload) => {
  const URL = `/drive/moves`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error occurred during create Share Link File Folder :",
      error,
    );
    throw error;
  }
};
